import { parseJSON } from './utils/parseJSON'
import Collection from './generic/collection'

const instance = '[data-js-choose-multiple]'
export const nodeWithListener = 'data-js-unset-choose-handler'

export class ChooseMultiple {

  els = {
    instance: instance,
    nodeWithListener: nodeWithListener,
    checkboxLabel: '.filter__btn'
  }

  stateClasses = {
    checked: 'filter__btn_selected'
  }
  bubbles = {
    unset: 'trigger::choose-unset'
  }

  constructor (instance) {
    this.instance = instance
    this.cfg = {
      filters: [],
      controls: {}
    }
    this.targetsToChoose = []
    this.targetState = null
    this.radioControls = []
    this.radioAllowedValues = []
    this.init()
    this.bindEvents()
  }

  setCfg (newCfg) {
    this.cfg = { ...this.cfg, ...parseJSON(newCfg) }
  }

  setClosestLinks (filtersContainer) {
    const closestLinks = filtersContainer.querySelectorAll('input[type="checkbox"]')
    closestLinks.forEach(node => {
      this.targetsToChoose.indexOf(node) < 0 && node.checked ? node.click() : false
    })
  }

  getControls () {
    if (Object.keys(this.cfg.controls).length > 0) {
      this.getRadioControls()
    }
  }

  getRadioControls () {
    const radioControls = this.cfg.controls?.radio

    if (radioControls) {
      radioControls.forEach(item => {
        document.querySelectorAll(`input[name=${item.selectName}]`).forEach(control => {
          this.radioControls.push(control)
        })
        this.radioAllowedValues.push(item.allowedValue)
      })
    }
  }

  setRadioControlsState () {
    let targetRadioNode = null
    this.radioAllowedValues.forEach(value => {
      targetRadioNode = this.radioControls.find(radioNode => {
        return radioNode.value === value
      })
    })
    targetRadioNode ? targetRadioNode.checked = true : false
  }

  setInstance (node) {
    !node.checked && this.targetState === true ? this.instance.checked = false : false
  }

  getTargetsToChoose (arrayId, container = document) {
    arrayId.forEach(targetId => {
      const targetNode = container.querySelector(`input[id="${targetId}"]`)
      targetNode ? this.targetsToChoose.push(targetNode) : false
    })
  }

  checkTargets () {
    this.targetsToChoose.forEach(node => {

      if (this.targetState) {
        this.checkCheckbox(node)
      } else {
        this.uncheckCheckbox(node)
      }
      /*      node.checked !== this.targetState ? node.click() : false
            !node.attributes.hasOwnProperty(this.els.nodeWithListener) ? this.addUnsetHandler(node) : false*/
      !node.attributes.hasOwnProperty(this.els.nodeWithListener) ? this.addUnsetHandler(node) : false
    })
  }

  checkCheckbox (checkbox) {
    checkbox.checked = true
    const checkboxLabel = checkbox.closest(this.els.checkboxLabel)
    if (checkboxLabel) {
      checkboxLabel.classList.add(this.stateClasses.checked)
    }
  }

  uncheckCheckbox (checkbox) {
    checkbox.checked = false
    const checkboxLabel = checkbox.closest(this.els.checkboxLabel)
    if (checkboxLabel) {
      checkboxLabel.classList.remove(this.stateClasses.checked)
    }
  }

  addUnsetHandler (node) {
    node.addEventListener('click', (e) => this.unsetBubble(e))
    node.dataset.jsUnsetChooseHandler = this.instance.id
  }

  unsetBubble ({ target }) {
    const targetCheckbox = document.querySelector(`#${target.getAttribute(this.els.nodeWithListener)}`)
    if (targetCheckbox) {
      this.uncheckCheckbox(targetCheckbox)
    }
  }

  static unsetBubble (target) {
    $(document).trigger(`trigger::choose-unset-${target.dataset.jsUnsetChooseHandler}`, [target])
  }

  choose ({ target }) {
    this.targetsToChoose = []
    this.targetState = target.checked
    this.cfg.filters.forEach(({ containerId, chooseFilter }) => {

      if (containerId) {
        const filtersContainer = document.querySelector(`[data-js-filter-id="${containerId}"]`)
        this.getTargetsToChoose(chooseFilter, filtersContainer)
        this.checkTargets()
        this.targetState ? this.setClosestLinks(filtersContainer) : false
        this.setRadioControlsState()
        return
      }

      this.getTargetsToChoose(chooseFilter)
      this.checkTargets()
      this.setRadioControlsState()
    })
  }

  handlerRadioControl ({ target }) {
    const allowedValue = this.radioAllowedValues.find(value => {
      return value === target.value
    })

    !allowedValue ? this.instance.checked = false : false
  }

  init () {
    this.setCfg(this.instance.dataset.jsChooseMultiple)
    this.getControls()
  }

  bindEvents () {
    this.instance.addEventListener('click', (e) => this.choose(e))
    this.radioControls.length > 0
      ? this.radioControls.forEach(item => {
        item.addEventListener('change', (e) => this.handlerRadioControl(e))
      })
      : false
    $(document).on(`${this.bubbles.unset}-${this.instance.id}`, (e, targetNode) => this.setInstance(targetNode))
  }
}

export default class ChooseMultipleCollection extends Collection {
  constructor () {
    super(instance, ChooseMultiple)
  }

  init () {
    document.querySelectorAll(this.els.instance).forEach(inst => {
      this.collection = new ChooseMultiple(inst)
    })
  }
}


